import * as yup from 'yup';

export default yup.object().shape({
  "password": yup.string().required().min(6),
  "password_confirmation": yup.string().oneOf([yup.ref('password'), null], 'Passwords must match').required(),
});

export const validationEmail = yup.object().shape({
  "email": yup.string().required().email(),
});